//import React, { Component } from 'react'
import React from 'react'
import { getClassTitle } from '../DataAndAPIs/ClassSections'
import { baseLink, videoLink } from '../Activities/Activity'

export const ActivityConfigVideo = (topic) => {
	const link = baseLink()+'configuration/'+topic+'.mp4'
	return ( <div>
		<h4>{getClassTitle()}</h4>
		{videoLink('', link)}
	</div> )
}